import { useContext } from "react";

import {
  ProductTileClickImpressionContext,
  IProductTileClickImpressionContextValue,
} from "@faire/retailer/hooks/ProductTileImpression/__internal__/ProductTileClickImpressionContext";

export const useProductTileClickImpressionContext =
  (): IProductTileClickImpressionContextValue => {
    return useContext(ProductTileClickImpressionContext);
  };
